import React from 'react';
import { Button, Form } from 'react-bootstrap';
import doller from '../../../assets/images/game/doller.svg';
import mines from '../../../assets/images/mines/mines.svg';
import whitegem from '../../../assets/images/mines/whitegem.svg';
import redgem from '../../../assets/images/header/gem.png';
// import xicon from '../../../assets/images/mines/x.svg';

const AutomatedTab = () => {
  return (
    <div className='manual-tab automated-tab'>
      <Form>
        <div className='mines-bet-box'>
          <Form.Group>
            <Form.Label>Bet Amount</Form.Label>
            <div className='bet-input pdd-200'>
              <img src={doller} alt='' />
              <Form.Control type='number' placeholder='58.52' />
              <div className='bet-input-btn'>
                <Button>1/2</Button>
                <Button>2x</Button>
                <Button>Max</Button>
              </div>
            </div>
          </Form.Group>
          <div className='automated-bet-half'>
          <Form.Group>
            <Form.Label>Mines</Form.Label>
            <div className='bet-input'>
              <img src={mines} alt='' />
              <Form.Control type='number' placeholder='20' />
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label>Bet</Form.Label>
            <div className='bet-input'>
              <img src={whitegem} alt='' />
              <Form.Control type='number' placeholder='3' />
            </div>
          </Form.Group>
          </div>
          <div className='on-win-section'>
          <Form.Group>
            <Form.Label>On Win</Form.Label>
            <div className='bet-input'>
              <div className='left-win-section'>
              <p>Reset</p>
              <p>Incresed By</p>
              </div>
              <Form.Control type='number' placeholder='50.00' />
              <span>%</span>
            </div>
          </Form.Group>
          </div>
          <Form.Group>
            <Form.Label>Stop on Profit</Form.Label>
            <div className='bet-input'>
              <img src={redgem} alt='' />
              <Form.Control type='number' placeholder='50.00' />
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label>Stop on Loss</Form.Label>
            <div className='bet-input'>
              <img src={redgem} alt='' />
              <Form.Control type='number' placeholder='50.00' />
            </div>
          </Form.Group>
        </div>
        <div className='roll-dice'>
          <Button>START AUTOBET </Button>
        </div>
      </Form>
      <div className='change-seed'>
        <Button>Change Seeds</Button>
      </div>
    </div>
  );
};

export default AutomatedTab;
